import { PROCESSOR_NAMES } from './constants';

/**
 * Check if a processor name matches a specific type
 * @param processorName - The processor name to check
 * @param processorValue - The processor value from PROCESSOR_NAMES
 * @returns True if the processor name matches the type
 */
export const isProcessorType = (
  processorName: string,
  processorValue: typeof PROCESSOR_NAMES[keyof typeof PROCESSOR_NAMES]
): boolean => {
  return processorName?.toLowerCase() === processorValue?.toLowerCase();
};

/**
 * Check if a processor is either Aeropay or Barterpay
 * @param processorName - The processor name to check
 * @returns True if the processor is Aeropay or Barterpay
 */
export const isAeropayOrBarterpay = (processorName: string): boolean => {
  return (
    isProcessorType(processorName, PROCESSOR_NAMES.AEROPAY) ||
    isProcessorType(processorName, PROCESSOR_NAMES.BARTERPAY)
  );
};
